export default __webpack_public_path__ + "static/media/Thug's Boots of the Grim Cabal.df202f9b.jpg";